/**
 * 腾讯云个人只读入口：build 时设 REACT_APP_PERSONAL_READONLY_PORTAL=1
 * 仅保留产品列表 + 产品详情，侧边栏精简；配合 SSH 隧道访问 127.0.0.1:3008
 */
export const isPersonalReadonlyPortal =
  process.env.REACT_APP_PERSONAL_READONLY_PORTAL === '1';

/** 腾讯云 admin.oldox.online 管理台 */
export const isTencentAdminPortal =
  process.env.REACT_APP_TENCENT_ADMIN === '1';

/** 决策分析站 decision.oldox.online */
export const isDecisionPortal =
  process.env.REACT_APP_DECISION_PORTAL === '1';

/** 本地开发：跳过登录，直接进页面（仅 dev，勿用于生产 build） */
export const isDecisionDevBypass =
  process.env.REACT_APP_DECISION_DEV_BYPASS === '1';
